import React, { createContext, useState } from 'react';

import TouchpointSubjectData from './TouchpointSubjectData';

export const TouchpointSubjectStateContext = createContext();

const TouchpointSubjectContextProvider = ({ children }) => {
  const stateHook = useState(TouchpointSubjectData.INITIAL_STATE);

  return (
    <TouchpointSubjectStateContext.Provider value={stateHook}>
      {children}
    </TouchpointSubjectStateContext.Provider>
  );
};

export default TouchpointSubjectContextProvider;